<div class="modal-overlay" (click)="close()">
  <div class="admin-modal" style="width: 750px;" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3 class="modal-title">Assign Template to Activity Roles</h3>
      <div class="header-actions">
        <i class="fa fa-times" style="cursor: pointer;" title="Close" (click)="close()"></i>
      </div>
    </div>
    <div class="modal-body">
      <div class="row" style="margin-bottom: 15px;">
        <div class="col-md-5">
          <label>Templates</label>
          <select class="form-control" [(ngModel)]="selectedTemplate" [ngModelOptions]="{standalone: true}">
            @for (t of allTemplates; track $index) {
<option [ngValue]="t">{{t.TEMPLATE_NAME}}</option>
}
          </select>
        </div>
        <div class="col-md-5">
          <label>Roles</label>
          <select class="form-control" [(ngModel)]="selectedTemplateRole" [ngModelOptions]="{standalone: true}">
            @for (r of activityRoles; track $index) {
<option [ngValue]="r">{{r.role_name}}</option>
}
          </select>
        </div>
        <div class="col-md-2" style="padding-top: 22px;">
          <button class="btn btn-success btn-sm" type="button" (click)="addTemplateMapping()">Add Mapping</button>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading"><h4 style="margin: 0;">Template Roles Mapping</h4></div>
        <div class="panel-body">
          @if (rolesTemplateMapping.length === 0) {
<div style="margin: 14px auto; text-align: center;">
            <span>No mappings added, please select above to add mappings</span>
          </div>
}
          @for (map of rolesTemplateMapping; track $index; let i = $index) {
<div class="row" style="margin-bottom: 6px;">
            <div class="col-md-4">
              <input type="text" class="form-control" [value]="map.template?.TEMPLATE_NAME" disabled>
            </div>
            <div class="col-md-4">
              <input type="text" class="form-control" [value]="map.role?.role_name" disabled>
            </div>
            <div class="col-md-1">
              <i style="font-size: 24px; cursor: pointer;" class="fa fa-minus-circle color-red" (click)="deleteTemplateMapping(i)"></i>
            </div>
          </div>
}
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-info btn-sm" type="button" (click)="saveRolesTemplateMapping()" [disabled]="rolesTemplateMapping.length < 1">
        Save @if (templateCrudLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
      </button>
      <button class="btn btn-warning btn-sm" type="button" (click)="close()">Cancel</button>
      <button class="btn btn-warning btn-sm" type="button" (click)="clearTemplateMapping()">Clear Form</button>
    </div>
  </div>
</div>
